import { render, staticRenderFns } from "./AddTrainingQualificationRecord.vue?vue&type=template&id=23b004a4"
import script from "./AddTrainingQualificationRecord.vue?vue&type=script&lang=ts"
export * from "./AddTrainingQualificationRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports